<template>
  <v-row  style="padding-left:10px;">
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="300px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          :color="isTargetShop ? '#000' : 'grey'"
          v-on="on"
          dark
          x-small
        >
        {{ $t("message.viewDetails") }}
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </template>
      <v-card style="width:100px">
        <v-card-title><strong>{{ $t("message.mounth") }}</strong></v-card-title>
        <v-card-text class="pa-0" style="height: 300px;">
          <v-timeline
        dense
        style="width:269px"
          >
        <v-timeline-item
          v-for="(item, i) in month1"
          :key="i"
          :color="(i+1)%2 === 0? 'teal lighten-3':'pink'"
          small
        >
          <v-row class="pt-1">
            <v-col cols="7">
              <strong>{{item.month}}</strong>
            </v-col>
            <v-col>
              <strong>{{item.total}}</strong> {{ $t("message.point") }}
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: ['month1'],
  data () {
    return {
      dialogm1: '',
      dialog: false,
      dialog1: false,
      member: null
    }
  },
  computed: {
    shopId () {
      return this.member && this.member.shopId ? this.member.shopId : null
    },
    isTargetShop () {
      try {
        return this.$isTargetShop()
      } catch (e) {
        return false
      }
    }
  },
  mounted () {
    this.member = this.GET_MEMBERINFO()
  },
  methods: {
    ...mapGetters('memberStore', ['GET_MEMBERINFO'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Card/Expiredialog1.vue